__turbopack_context__.v({
  "card": "WIIGGG_card",
  "expander": "WIIGGG_expander",
  "kindBadge": "WIIGGG_kindBadge",
  "roleList": "WIIGGG_roleList",
});
